import React from 'react';
import { IPublishApprovalFlowModel } from '@Shared.Angular/@types/core/contracts/queryModel/flowModels/publishApprovalFlowModel';
import ApprovalList from '../ApprovalList';

interface Props {
  isMobile: boolean;
  filteredFlowModels: IPublishApprovalFlowModel[];
}

const AllApprovalList: React.FC<Props> = ({ isMobile, filteredFlowModels }) => {
  return (
    <ApprovalList
      isMobile={isMobile}
      filteredFlowModels={filteredFlowModels}
      roleLabel="Author"
      emptyStateData={{
        summaryText: 'No active approval requests',
        bodyText:
          'There are no flow models currently awaiting approval in your organisation'
      }}
    />
  );
};

export default AllApprovalList;
